import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectItemsReducer(state = initialState.projectItems, action) {

    const mergeInProjectItem = (projectItems, projectItemUpdate) => {
        if (projectItemUpdate.id < 1) {
            return projectItems;
        }
        const projectItemsMinusStaleData = projectItems.filter(projectItem => projectItem.id !== projectItemUpdate.id);       
        return projectItemsMinusStaleData.concat(projectItemUpdate);
    }

     const deleteProjectItem = (current, id) => {
        return current.filter(projectItem => projectItem.id !== id);
    } 


    switch (action.type) {
        case types.LOAD_PROJECTITEM_SUCCESS:
        case types.UPDATED_PROJECTITEM_SUCCESS:
            return mergeInProjectItem(state, action.projectItem);
            case types.DELETED_PROJECTITEM:      
            return deleteProjectItem(state, action.projectItem.id);      
        case types.DELETED_PROJECTITEM_INCOMING:        
            return deleteProjectItem(state, action.payload.id);    
        default:
            return state;
    }
}

